import React, { useState, useEffect } from "react";

import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import useTable from "../useTable";
import axios from "axios";
import { Toasts } from "../toasts";
//import { ActualizarUsuario } from "./modalUsuarioAdministracion";
import { CambiarClave } from "../comun/modalCambiarClave";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { ActualizarUsuarioGeneral } from "../modalesGenerales/modalUsuario";

function TablaUsuarioAdministracion(props) {
  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  const [activate, setActivate] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [idUsuarioH, setIdUsuarioH] = useState(0);
  const [persona, setPersona] = useState();
  const [usuarioH, setUsuarioH] = useState();
  const [idUsuario, setIdUsuario] = useState();
  const [usuariow, setUsuariow] = useState();
  const [mostrar2, setMostrar2] = useState(false);
  const [deuda, setDeuda] = useState();
  const [operacion, setOperacion] = useState();
  const permiso = JSON.parse(localStorage.getItem("accusuarioadmini")) === null ? "0000" : JSON.parse(localStorage.getItem("accusuarioadmini"));
  const [records, setRecords] = useState([]);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const [deshabilitado] = useState(false);
  const [configCome] = useState();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const headCells = [
    {
      id: "idinmueble",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "numficha",
      label: "USUARIO",
      width: "70px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrepropie",
      label: "NOMBRES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "dirinmueble",
      label: "OPCIONES",
      width: "250px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idusuario.includes(target.value) ||
              x.login.toLowerCase().includes(target.value.toLowerCase()) ||
              (x.nombres + " " + x.apellidos)
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const renderizar = () => {
    setMostrar5(false);
    setPersona();
    setUsuarioH();
    seleccionarUsuarios();
  };
  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    setEspiritu(obj.espiritu);
    seleccionarUsuarios();
  }, []);

  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };
  const seleccionarUsuarios = () => {
    setActivate(true);
    let endpoint = op.conexion + `/api/administracion/modulouser`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setRecords(response.data);
            setActivate(false);
          } else {
            setRecords([]);
          }
        }
        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
  };
  const gestionarUsuario = (index, op, per) => (event) => {
    event.preventDefault();
    setOperacion(op);
    if (per.toString() === "1") {
      if (op === 1) {
        setMostrar5(true);
      } else {
        setIdUsuarioH(index.idusuario);
        setActivate(true);
        setPersona({
          cedula: index.cedula,
          nombres: index.nombres,
          apellidos: index.apellidos,
          correoe: index.correoe,
          tlf1: index.tlf1,
          tlf2: index.tlf2,
          fnacimiento: index.fnacimiento,
          nacionalidad: index.nacionalidad,
          sexo: index.sexo,
          direccion: index.direccion,
        });
        setUsuarioH(index);
        setMostrar5(true);
        setActivate(false);
      }
    } else {
      setToast({
        mostrar: true,
        mensaje:
          op === 1
            ? "No posee permiso para Registrar"
            : op === 2
              ? "No posee permiso para Editar"
              : op === 3
                ? "No posee permiso para Eliminar"
                : "No posee permiso para Consultar",
        titulo: "Alerta.",
      });
    }
  };
  const cerrarModalActualizar = () => {
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
  };

  const validarActuUsuario = () => {
    if (operacion === 4) {
      setUsuarioH();
      setMostrar5(false);
      return;
    }
    if (operacion === 1) {
      setIdUsuarioH(0);
    }
    setUsuarioH();
    setUsuariow();
    setPersona();
    setMostrar5(false);
    window.location.href = "/usuariosHacienda";
  };

  const cambiarClave = () => {
    setMostrar2(true);
  };

  const handleCloseClave = () => {
    setMostrar2(false);
  };
  const cerrar = () => {
    props.setTabla(0);
  };


  const permisosConfigTesoreria = [
    // --- TAB: INSTALACIÓN ---
    { label: "Bancos", key: "accbanco", type: "check", tab: "Instalacion", valor: "0000" },
    { label: "Cuentas Bancarias", key: "acccuentabancaria", type: "check", tab: "Instalacion", valor: "0000" },
    { label: "Cambio de Año Fiscal", key: "acccambioefiscal", type: "radio", tab: "Instalacion", valor: "0" },
    { label: "Tipo de Retenciones", key: "acctiporetencion", type: "check", tab: "Instalacion", valor: "0000" },

    // --- TAB: ADMINISTRACIÓN ---
    { label: "Egresos", key: "accegresos", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Depositos", key: "accdeposito", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Trans. Bancaria", key: "acctransferenciabanc", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Reversar Pagos de Egreso", key: "accrereverspagar", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Conci. Bancaria", key: "accconciliacion", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Cheques Anulados", key: "acccheqanul", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Reversar/Elminar Depósitos Bancarios", key: "accrereversdeposito", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Notas de Débito", key: "accdebito", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Notas de Crédito", key: "acccredito", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Reversar Egresos", key: "accrereversegreso", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Ordenes de Pago", key: "acccausar", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Aprobar Ordenes de Pago", key: "accaproborden", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Modificar Retenciones", key: "accmodreten", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Env. Cheque Caja y Dev. Cheque Tesorería", key: "accenvchecausar", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Pago a Fondos de Terceros", key: "accfondotercero", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Pago de Ordenes", key: "accpagoordenes", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Despacho del Alcalde", key: "acccontrolinterno", type: "radio", tab: "Administracion", valor: "0" },
    //{ label: "Operaciones Especiales", key: "accespecial", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Administrador", key: "accadministrador", type: "radio", tab: "Administracion", valor: "0" },
    { label: "Reversar Ordenes de Pago", key: "accrereversordenpago", type: "radio", tab: "Administracion", valor: "0" },

    // --- TAB: REPORTES ---
    { label: "Ordenes de Pago", key: "accrepordenpago", type: "radio", tab: "Reportes", valor: "0" },
    { label: "Bancos", key: "accrepbanco", type: "radio", tab: "Reportes", valor: "0" },
    { label: "Retenciones", key: "accrepretencion", type: "radio", tab: "Reportes", valor: "0" },
    //{ label: "Fondos de Terceros", key: "accrepfondoterc", type: "radio", tab: "Reportes", valor: "0" },
    { label: "Control de Obras", key: "accrepobras", type: "radio", tab: "Reportes", valor: "0" },

    // --- TAB: USUARIOS ---
    { label: "Módulo de Usuarios", key: "accusuarioadmini", type: "check", tab: "Usuarios", valor: "0000" },
    { label: "Supervisor Administrador", key: "superadmin", type: "check", tab: "Usuarios", valor: "0" },
    { label: "Supervisor Tesorería", key: "superteso", type: "check", tab: "Usuarios", valor: "0" },
    
  ];
  const tabsConfigTesoreria = [
    {
      id: "tab-datos",
      label: "Usuario",
      type: "static",
      colorClass: "bg-blue-100 text-dark text-uppercase fw-bold",
      contentId: "content-datos"
    },
    {
      id: "tab-permisos",
      label: "Permisos de Aplicaciones",
      type: "dynamic",
      colorClass: "bg-blue-200 text-dark text-uppercase fw-bold",
      contentId: "content-permisos",
      subTabs: [
        { id: "sub-instalacion", label: "Instalación", filterValue: "Instalacion", colorClass: "bg-blue-100 text-dark text-uppercase fw-bold" },
        { id: "sub-administracion", label: "Administración", filterValue: "Administracion", colorClass: "bg-blue-200 text-dark text-uppercase fw-bold" },
        { id: "sub-reportes", label: "Reportes", filterValue: "Reportes", colorClass: "bg-blue-300 text-dark text-uppercase fw-bold" },
        { id: "sub-usuarios", label: "Usuarios", filterValue: "Usuarios", colorClass: "bg-blue-400 text-dark text-uppercase fw-bold" }
      ]
    }
  ];

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 mb-2 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="m-0">Usuarios</h3>
        <a onClick={cerrar} type="button">
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form onSubmit={(e) => { e.preventDefault() }}
        className="col-12 m-0 p-2 d-flex justify-content-between">
        <div className="col-4 m-0 p-0">
          <Input
            placeholder="Buscar"
            onChange={handleSearch}
            aria-label="Search"
          />
        </div>
        <div className="d-flex gap-2">
          <PrimaryButton icon='fa-key'
            disabled={
              permiso &&
              permiso.substring(1, 2) !== "1" &&
              permiso.substring(2, 3) !== "1"
            }
            onClick={cambiarClave}
          >
            Cambiar Clave
          </PrimaryButton>
          <PrimaryButton icon='fas fa-plus m-0'
            onClick={gestionarUsuario(
              "",
              1,
              permiso.toString().substring(1, 2)
            )}
            disabled={
              permiso.toString().substring(1, 2) !== "1"
            }
          >
          </PrimaryButton>
        </div>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idusuario} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //  width: "10px",
                    }}
                  >
                    {item.idusuario}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "70px",
                    }}
                  >
                    {item.login}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      //width: "250px",
                    }}
                  >
                    {item.nombres}
                  </td>
                  <td
                    align="center"
                    className="align-baseline"
                    style={{
                      fontSize: "10px",
                      textAlign: "center",
                      width: "180px",
                      padding: 0,
                    }}
                  >
                    <button
                      onClick={gestionarUsuario(
                        item,
                        4,
                        permiso.toString().substring(0, 1)
                      )}
                      className={
                        permiso.toString().substring(0, 1) === "1"
                          ? "btn btn-sm btn-info rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        2,
                        permiso.toString().substring(2, 3)
                      )}
                      className={
                        permiso.toString().substring(2, 3) === "1"
                          ? "btn btn-sm btn-warning rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                      onClick={gestionarUsuario(
                        item,
                        3,
                        permiso.toString().substring(3, 4)
                      )}
                      className={
                        permiso.toString().substring(3, 4) === "1"
                          ? "btn btn-sm btn-danger rounded-circle"
                          : "btn btn-sm btn-secondary rounded-circle"
                      }
                    >
                      <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
      <ActualizarUsuarioGeneral
        show={mostrar5}
        onHideCancela={cerrarModalActualizar}
        onHideAcepta={validarActuUsuario}
        usuario={usuarioH}
        datospersonales={persona}
        deshabilitado={deshabilitado ? deshabilitado : undefined}
        ingresa={0}
        declaweb={configCome ? configCome[0].declaweb.toString() : "false"}
        idusuario={idUsuario}
        operacion={operacion}
        render={renderizar}
        permisosConfig={permisosConfigTesoreria} // Pasas el array de permisos
        tabsConfig={tabsConfigTesoreria}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <CambiarClave show={mostrar2} onHide={handleCloseClave} />
    </div>
  );
}
export default TablaUsuarioAdministracion;
